/* eslint-disable no-undef */
// Firebase web SDK config. Values can be overridden per environment via
// REACT_APP_FIREBASE_* env vars (wired up in .github/workflows/deploy.yml).
//
// Today every environment (dev / hom / prod) is set to point at the
// `yapps-dev` Firebase project — the same project we've been using since
// launch. To split prod onto a separate Firebase project (e.g. `yapps-prod`):
//   1. Migrate users from yapps-dev → yapps-prod (Firebase Auth export/import)
//   2. Update the GitHub `prod` environment variables
//      (REACT_APP_FIREBASE_*) to the yapps-prod values
//   3. Redeploy web prod
// No code change needed for the split.
export const config = {
  apiKey:
    process.env.REACT_APP_FIREBASE_API_KEY ||
    'AIzaSyBWP-hEYXDKL2W3VxdfGUIMvmKtZBI81hc',
  authDomain:
    process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'yapps-dev.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'yapps-dev',
  storageBucket:
    process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'yapps-dev.appspot.com',
  messagingSenderId:
    process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '296989612559',
  appId:
    process.env.REACT_APP_FIREBASE_APP_ID ||
    '1:296989612559:web:2ffdc3a366133f9db5217a',
  measurementId:
    process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || 'G-WG945C91Z0',
};

export default config;
